import {
  GENERATE_API_KEY,
  GENERATE_API_KEY_SUCCESS,
  GENERATE_API_KEY_FAIL,
  GET_RESELLER_CLIENT_DATA,
  GET_RESELLER_CLIENT_DATA_SUCCESS,
  GET_RESELLER_CLIENT_DATA_FAIL,
  TenWebApiAction,
  GenerateApiKeySuccess,
  GetResellerClientDataSuccess,
  GET_RESELLER_MAIN_DOMAIN,
  GET_RESELLER_MAIN_DOMAIN_SUCCESS,
  GET_RESELLER_MAIN_DOMAIN_FAIL,
  LOAD_WORDPRESS_PLUGIN_DETAILS,
  LOAD_WORDPRESS_PLUGIN_DETAILS_SUCCESS,
  LOAD_WORDPRESS_PLUGIN_DETAILS_FAIL,
  LoadWordPressPluginDetailsSuccess
} from '../actions/10web-api.actions';

export interface ITenWebApiState {
  loading: boolean;
  loaded: boolean;
  error: any;
  apiKey: string | null;
  apiKeyGenerated: boolean;
  apiKeyCreatedAt: string | null;
  webhookUrl: string | null;
  domain?: { main_domain: string, status: string };
  products?: {
    '10web_products'?: any[];
    wp_products?: any[];
  };
  enhancedPlugins?: any[];
}

export const initialState: ITenWebApiState = {
  loading: false,
  loaded: false,
  error: null,
  apiKey: null,
  apiKeyGenerated: false,
  apiKeyCreatedAt: null,
  webhookUrl: null,
  domain: null,
  products: null,
  enhancedPlugins: null
};

export function reducer(state: ITenWebApiState = initialState, action: TenWebApiAction): ITenWebApiState {
  let payload: any;

  switch (action.type) {
    case GENERATE_API_KEY:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GENERATE_API_KEY_SUCCESS:
      payload = (<GenerateApiKeySuccess>action).payload;
      return {
        ...state,
        loading: false,
        apiKey: payload.data?.api_key,
        apiKeyGenerated: true,
        apiKeyCreatedAt: payload.data?.api_key_created_at
      };

    case GENERATE_API_KEY_FAIL:
      return {
        ...state,
        loading: false,
        error: (<any>action).payload
      };

    case GET_RESELLER_CLIENT_DATA:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };

    case GET_RESELLER_CLIENT_DATA_SUCCESS:
      payload = (<GetResellerClientDataSuccess>action).payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        apiKeyGenerated: payload.data?.api_key_generated,
        apiKeyCreatedAt: payload.data?.api_key_created_at,
        webhookUrl: payload.data?.webhook_url,
        products: payload.data?.products || null
      };

    case GET_RESELLER_CLIENT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: (<any>action).payload
      };

    case GET_RESELLER_MAIN_DOMAIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_RESELLER_MAIN_DOMAIN_SUCCESS:
      payload = (<GetResellerClientDataSuccess>action).payload;
      return {
        ...state,
        loading: false,
        domain: payload.data
      };

    case GET_RESELLER_MAIN_DOMAIN_FAIL:
      return {
        ...state,
        loading: false,
        error: (<any>action).payload
      };

    case LOAD_WORDPRESS_PLUGIN_DETAILS:
      return {
        ...state,
        loading: true,
        error: null
      };

    case LOAD_WORDPRESS_PLUGIN_DETAILS_SUCCESS:
      payload = (<LoadWordPressPluginDetailsSuccess>action).payload;
      return {
        ...state,
        loading: false,
        enhancedPlugins: payload.enhancedPlugins
      };

    case LOAD_WORDPRESS_PLUGIN_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: (<any>action).payload
      };

    default:
      return state;
  }
}
